import {
  Box,
  MenuItem,
  Button,
  FormControl,
  Grid,
  IconButton,
  LinearProgress,
  Link,
  ListItemText,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Filter } from '../../../components/_WMS/FilterComponent'
import React, { Fragment, useEffect, useState } from 'react'
import HelpIcon from '@mui/icons-material/Help'
import { Selector } from '../../../components/Selector'
import { eTypeInventoryCheck } from '../../../enums/eInventoryCheck'
import GenericTransferElements from '../../../components/_WMS/GenericTransferElementsComponent/GenericTransferElementsComponent'
import {
  getInventoryCheckTemplate,
  getInventoryCheckUsersList,
  postInventoryCheck
} from '../api'
import { useApi } from '../../../hooks/useApi'
import {
  InventoryCheckUser,
  InventoryCheckUserDetailnfoDto
} from '../entities/InventoryCheck'
import { Loading } from '../../../components/UI/Loading/Loading'
import { Status } from '../../../hooks/useFetchState'
import { useWarehouses } from '../../../hooks'

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 15,
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: '#EEEEEE'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }
}))(LinearProgress)

interface CreateInventoryCheckModalProps {
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  requestInventoryCheck: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const CreateInventoryCheckModal: React.FC<
  CreateInventoryCheckModalProps
> = ({ handleSnackbar, handleCloseModal, requestInventoryCheck }) => {
  const [currentFile /*, setCurrentFile */] = useState<any | undefined>(
    undefined
  )
  const [progress, setProgress] = useState<number>(0)
  const [rigthUser, setRigthUser] = useState<InventoryCheckUser[]>([])

  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )

  const [qtyCycles, setQtyCycles] = useState<number>(2) // Valor por defecto en 2, de acuerdo a la historia
  const [promiseDate, setpromiseDate] = useState<string>('') // Valor inicial vacío para datePicker
  const [selectedTypeOrder, setSelectedTypeOrder] = React.useState<number>(
    eTypeInventoryCheck.Ciclicos
  )

  const [loading, setLoading] = useState<boolean>(false)

  const { state, callApi } = useApi<InventoryCheckUserDetailnfoDto>()

  const { state: requestLabelState, callApi: requestDownloadTemplate } =
    useApi()
  const [selectedWarehouse, setSelectedWarehouse] = useState<number>(-1)

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    } else if (warehouses?.length === 1) {
      setSelectedWarehouse(warehouses[0].id)
    }
  }, [warehouses])

  const handleSetTypeOrder = (value: number) => {
    setSelectedTypeOrder(value)
  }

  const handleSetWarehouse = (id: number) => {
    setSelectedWarehouse(id)
  }
  const handleDatePickerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setpromiseDate(e.target.value) // La fecha se maneja como string en formato YYYY-MM-DD
  }

  const handleQtyCyclesChange = (qty: number) => {
    setQtyCycles(qty)
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
  }

  const validateButtonLoad = () => {
    if (!selectedFiles || rigthUser.length === 0 || selectedWarehouse <= 0)
      return true
    else return false
  }

  const handleSubmit = () => {
    setLoading(true)

    const formData = new FormData()

    // Agregar los valores del formulario
    // formData.append('users', rigthUser.toString() );
    formData.append('typeOrderId', selectedTypeOrder.toString())
    formData.append('qtyCycles', qtyCycles.toString())
    formData.append('promiseDate', promiseDate)
    formData.append('warehouseId', `${selectedWarehouse}`)

    rigthUser.forEach((user) => {
      formData.append('users', user.userId.toString())
    })

    // Agregar el archivo seleccionado
    if (selectedFiles && selectedFiles.length > 0)
      formData.append('file', selectedFiles[0])

    callApi(postInventoryCheck(formData))
      .then(() => {
        handleSnackbar('Carga realizada exitosamente', true)
        requestInventoryCheck()
        handleCloseModal()
      })
      .catch((error) => {
        requestInventoryCheckUsers()
        handleSnackbar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDownloadTemplate = () => {
    setLoading(true)

    requestDownloadTemplate(getInventoryCheckTemplate())
      .then((response) => {
        const raw = window.atob(response.file)
        const uInt8Array = new Uint8Array(raw.length)
        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }
        const link = document.createElement('a')
        const blob = new Blob([uInt8Array], {
          type: response.mimeType
        })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', response.name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleRightItemsChange = (updatedRightItems: InventoryCheckUser[]) => {
    setRigthUser(updatedRightItems)
  }

  const requestInventoryCheckUsers = () => {
    setLoading(true)
    callApi(getInventoryCheckUsersList())
      .then(() => {
        setLoading(false)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
    setLoading(false)
  }

  const qtyCyclesComponent = [1, 2].map((cycle) => (
    <MenuItem key={cycle} value={cycle}>
      {cycle}
    </MenuItem>
  ))

  useEffect(() => {
    requestInventoryCheckUsers()
  }, [])

  if (state.status === Status.Loading || loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Fragment>
        <Typography></Typography>
        <Grid
          container
          spacing={2} // Espaciado entre los elementos
          justifyContent='center'
          alignItems='center'
          style={{ textAlign: 'center' }}
        >
          <Grid
            item
            xs={4}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <FormControl>
              <Selector
                labelId='selectedTypeOrder'
                label='Tipo Orden'
                item={Object.keys(eTypeInventoryCheck)
                  .filter((key) => isNaN(Number(key))) // Filtra las claves numéricas
                  .map((key) => ({
                    value:
                      eTypeInventoryCheck[
                        key as keyof typeof eTypeInventoryCheck
                      ],
                    name: key
                  }))}
                onChange={(e: any) =>
                  handleSetTypeOrder(e.target.value as number)
                }
                id='typeOrderId'
                name='typeOrderId'
                value={selectedTypeOrder}
                variant='outlined'
              />
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <FormControl>
              <TextField
                id='qtyCycles'
                name='qtyCycles'
                label='Cantidad de Ciclos'
                value={qtyCycles}
                onChange={(e: any) =>
                  handleQtyCyclesChange(e.target.value as number)
                }
                variant='outlined'
                select
                fullWidth
              >
                {qtyCyclesComponent}
              </TextField>
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <FormControl>
              <TextField
                id='promiseDate'
                name='promiseDate'
                label='Fecha Compromiso'
                type='date'
                value={promiseDate}
                onChange={handleDatePickerChange}
                variant='outlined'
                InputLabelProps={{
                  shrink: true // Asegura que el label no se superponga al valor
                }}
              />
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <FormControl>
              <Selector
                labelId='selectedWarehouse'
                item={
                  warehouses &&
                  warehouses.map((item) => ({
                    value: item.id,
                    name: item.warehouseName
                  }))
                }
                defaultLabel='Almacén'
                onChange={(e: any) =>
                  handleSetWarehouse(e.target.value as number)
                }
                id='warehouseId'
                name='warehouseId'
                value={selectedWarehouse}
                variant='outlined'
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <hr />

        <GenericTransferElements
          availableItems={state.data?.availableUsers || []}
          items={rigthUser || []}
          getKey={(user) => user.userId}
          getLabel={(user) => user.username}
          leftTitle='Usuarios Disponibles'
          rightTitle='Usuarios Asignados'
          onRightItemsChange={handleRightItemsChange}
        />

        <br />
        <hr />
        <Box className='mb25' display='flex' alignItems='center'>
          <Grid
            container
            spacing={4}
            direction='row'
            alignItems='center'
            justifyContent='center'
            style={{ justifyContent: 'center' }}
          >
            <Grid item xs={3} style={{ textAlign: 'right' }}>
              <label htmlFor='btn-upload'>
                <input
                  id='btn-upload'
                  name='btn-upload'
                  style={{ display: 'none' }}
                  type='file'
                  onChange={handleSelectFile}
                  accept='.xls,.xlsx'
                />
                <Tooltip
                  title='Seleccionar el archivo Excel a cargar'
                  placement='top-end'
                >
                  <Button
                    className='btn-choose'
                    variant='outlined'
                    component='span'
                  >
                    Seleccionar Archivo
                  </Button>
                </Tooltip>
              </label>
            </Grid>

            <Grid item xs={5}>
              <div className='file-name'>
                {selectedFiles && selectedFiles.length > 0
                  ? selectedFiles[0].name
                  : null}
              </div>
            </Grid>

            <Grid item xs={1}>
              <Tooltip
                title='Enviar el archivo seleccionado al servidor para su procesamiento'
                placement='top-end'
              >
                <Button
                  className='btn-upload'
                  color='primary'
                  variant='contained'
                  component='span'
                  disabled={validateButtonLoad()}
                  onClick={handleSubmit}
                >
                  Cargar
                </Button>
              </Tooltip>
            </Grid>

            <Grid
              item
              xs={1}
              alignContent='center'
              style={{ textIndent: '15px' }}
            >
              <Tooltip
                title='Oprima el botón SELECCIONAR para elegir el archivo a subir y luego el botón CARGAR para enviar el archivo al servidor para su procesamiento'
                placement='top-end'
              >
                <IconButton>
                  <HelpIcon />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              style={{ padding: '0px', marginBottom: '25px' }}
            >
              <ListItemText
                primary={''}
                secondary={
                  <Box>
                    <Typography component='ol' style={{ listStyle: 'square' }}>
                      <Typography
                        variant='subtitle1'
                        component='li'
                        gutterBottom
                      >
                        Puede descargar una <b>plantilla</b> desde el link que
                        se encuentra disponible a continuación.
                        <br />
                        {requestLabelState.status === Status.Loading ? (
                          <Fragment>
                            <div>
                              <Typography>
                                <Loading />
                              </Typography>
                            </div>
                          </Fragment>
                        ) : (
                          <Link
                            style={{ cursor: 'pointer' }}
                            onClick={handleDownloadTemplate}
                          >
                            Descargar Plantilla
                          </Link>
                        )}
                      </Typography>
                    </Typography>
                  </Box>
                }
              />
            </Grid>
          </Grid>
        </Box>

        <div
          style={{
            margin: '10px',
            visibility: currentFile ? 'visible' : 'hidden'
          }}
        >
          <BorderLinearProgress variant='determinate' value={progress} />

          <Box minWidth={35}>
            <Typography
              variant='body1'
              color='textSecondary'
              style={{ textAlign: 'end' }}
            >{`${progress}%`}</Typography>
          </Box>
        </div>
      </Fragment>
    )
  }
}
